import React, { FunctionComponent } from 'react';

import SpotClusterMarker from 'components/SpotClusterMarker';

import styles from '../SpotMap.module.scss';

interface ClusterData {
  geometry: {
    coordinates: [number, number];
  };
  properties: {
    spotCount: number;
    worstCondition: string;
    bestCondition: string;
  };
}

interface ClusterMarkerOverlayProps {
  cluster: ClusterData;
  style: React.CSSProperties;
  onClick: () => void;
}

/**
 * Renders a cluster marker overlay
 */
const ClusterMarkerOverlay: FunctionComponent<ClusterMarkerOverlayProps> = ({
  cluster,
  style,
  onClick,
}) => {
  const [lon, lat] = cluster.geometry.coordinates;
  const { spotCount, worstCondition, bestCondition } = cluster.properties;

  return (
    <div
      className={styles.spotMapOverlayMarker}
      data-testid="spot-cluster-marker"
      key={`${lat},${lon}`}
      style={style}
    >
      <SpotClusterMarker
        bestCondition={bestCondition}
        onClick={onClick}
        spotCount={spotCount}
        worstCondition={worstCondition}
      />
    </div>
  );
};

export default ClusterMarkerOverlay;
